import { db } from '../config/firebase';
import { collection, addDoc, getDocs, deleteDoc, doc } from 'firebase/firestore';

interface Category {
  id?: string;
  name: string;
  createdAt: Date;
}

const categoriesCollection = collection(db, 'categories');

export const addCategory = async (name: string): Promise<void> => {
  try {
    await addDoc(categoriesCollection, {
      name: name.trim(),
      createdAt: new Date()
    });
  } catch (error) {
    console.error('Error adding category:', error);
    throw error;
  }
};

export const removeCategory = async (categoryId: string): Promise<void> => {
  try {
    await deleteDoc(doc(categoriesCollection, categoryId));
  } catch (error) {
    console.error('Error removing category:', error);
    throw error;
  }
};

export const getCategories = async (): Promise<Category[]> => {
  try {
    const querySnapshot = await getDocs(categoriesCollection);
    return querySnapshot.docs.map(doc => {
      const data = doc.data();
      return {
        id: doc.id,
        name: data.name || '',
        createdAt: data.createdAt?.toDate() || new Date()
      } as Category;
    });
  } catch (error) {
    console.error('Error getting categories:', error);
    throw error;
  }
};
